export default {"src":"/_next/static/media/essentials.877fdff4.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};